import Axios from "axios";
import { SETTINGS } from "../../../../../properties/ApiProps";

export const ProfessionalTitleTypeRepository = {
  fetch: (id) => {
    return Axios.get(`${SETTINGS.API_URL}professionalTitleType/${id}`);
  },
  fetchAll: (gradingSchemaId) => {
    return Axios({
      url: SETTINGS.API_URL + "professionalTitleType",
      method: "GET",
      params: { gradingSchemaId: gradingSchemaId },
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  create: (data) => {
    return Axios({
      url: SETTINGS.API_URL + "professionalTitleType",
      method: "POST",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  update: (data) => {
    return Axios({
      url: SETTINGS.API_URL + "professionalTitleType",
      method: "PUT",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  delete: (id) => {
    return Axios.delete(`${SETTINGS.API_URL}professionalTitleType/${id}`);
  },
};
